// 리코일 사용안함 -> state.js 이용할것
import { atom } from "recoil";

const api = process.env.NODE_ENV==='production'?'https://api.docircuit.org:3001':'http://127.0.0.1:3001'

export const loginState = atom({
  key:"loginState",
  default: {
    mcd : '',
    level : ''
  }
})

export const configState = atom({
  key:"configState",
  default: {
    cid: 'CID000000HR',
    name: '두써킷 (HR)',
    api:api
  }
})